import request from '@/utils/request';

const PATH = '/stay/cancel/policy';

export const getStayCancelPolicyList = () => request({
  url: PATH,
  method: 'get',
});

export const getStayCancelPolicy = (idx: any) => request({
  url: `${PATH}/${idx}`,
  method: 'get',
});

export const addStayCancelPolicy = (data: any) => request({
  url: PATH,
  method: 'post',
  data,
});

export const updateStayCancelPolicy = (idx: any, data: any) => request({
  url: `${PATH}/${idx}`,
  method: 'put',
  data,
});

export const deleteStayCancelPolicy = (idx: any) => request({
  url: `${PATH}/${idx}`,
  method: 'delete',
});
